<template>
  <main v-bind="dKey('pageid', pageName, pageId)">
    <section class="prev-page-section" style="background-image:url(/static-assets/img/contact-img.jpg);">
      <div class="container">
        <div v-bind="dKey('bgTitle')" class="grey-title-block resp-number">{{info.bgTitle}}</div>
      </div>
    </section>
    <section class="news-section">
        <div class="container">
          <div class="row title-wrapper">
            <div class="col-sm-6 wow fadeInLeft" data-wow-duration="2s" data-wow-delay=".5s">
              <span v-bind="dKey('subtitle')" class="section-title">{{info.subtitle}}</span>
              <h3 v-bind="dKey('title')">{{info.title}}</h3>
            </div>
            <div class="col-sm-6 text-right p-0 wow fadeInRight" data-wow-duration="2s" data-wow-delay=".5s">
              <span v-bind="dKey('bgSubTitle')" class="big-title-st resp-number p-0">{{info.bgSubTitle}}</span>
            </div>
          </div>
          <div class="row news-overview-wrapper">
            <Article v-for="(post, index) in posts"
                     v-bind:key="index"
                     v-bind:title="post.title"
                     v-bind:content="post.content"
                     v-bind:href="post.url"
                     v-bind:image="post.image"
                     v-bind:date="post.date">
            </Article>
          </div>
        </div>
    </section>
  </main>
</template>

<script>

import {HTTP} from '../http-common'

import Article from './Article.vue'

export default {
  name: 'News',

  data() {
    return {
      info: {},
      pageId: 0,
      pageName: 'news',
      posts: [],
      errors: []
    }
  },

  mounted() {
    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })
  },

  created() {
    this.$root.getPage('news', this.$root.language_id, response => {
      this.info = response.info
      this.pageId = response.pageId

      this.getNews()
    })
  },

  watch:{
    $route (to, from) {
      this.$root.getPage('news', this.$root.language_id, response => {
        this.info = response.info
        this.pageId = response.pageId

        this.getNews()
      })
    }
  },

  methods: {
    dKey(key, page, pageId) {
      return this.$root.dKey(key, page, pageId)
    },

    getNews() {
      let filter = 'filter[where][status]=publish&'

      if (this.$root.isAdmin()) filter = ''

      HTTP.get('pages/' + this.pageId + '/post?' + filter + 'filter[order]=date DESC').then(response => {
        if (response.status == 200) {
          this.posts = []

          response.data.forEach(post => {
            let article = post

            article.date = new Date(post.date)

            let day = article.date.getDate(),
                month = article.date.getMonth() + 1

            month = month < 10 ? '0' + month : month
            day = day < 10 ? '0' + day : day

            article.date = day + '.' + month + '.' + article.date.getFullYear()
            article.content = article.content.replace(/(<([^>]+)>)/ig, '')

            if (article.content.length > 106)
              article.content = article.content.substr(0, 106) + '...'

            article.url = '/' + this.$root.locale + '/news/' + article.url

            this.posts.push(article)
          })
        }
      }).catch(e => {
        this.errors.push(e)
      })
    }
  },

  components: {
    Article
  }
}

</script>
